var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('span',{staticClass:"my-2",class:{
      'font-weight-bold': !_vm.child,
    }},[_vm._v(" "+_vm._s(_vm.order)+_vm._s(!_vm.parent ? "." : "")+" "+_vm._s(_vm.name)+" ")]),_c('br'),(!_vm.child)?_c('small',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),(_vm.child)?_c('item-question-name',{staticClass:"my-2",attrs:{"child":_vm.child.child,"parent":_vm.child.parent,"order":`${_vm.order}.${_vm.child.order}`,"name":_vm.child.name,"description":_vm.child.description}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }